import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CaretRightSquare"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.75 6.75L15.75 12L9.75 17.25V6.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.5 21H19.5C20.3281 20.9992 20.9992 20.3281 21 19.5V4.5C20.9992 3.67192 20.3281 3.00083 19.5 3H4.5C3.67192 3.00083 3.00083 3.67192 3 4.5V19.5C3.00083 20.3281 3.67192 20.9992 4.5 21ZM4.5 19.5V4.5H19.5L19.5007 19.5H4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CaretRightSquare.vue"]]);
